'use strict';

import React from 'react';

import { Form, Select, Row, Col, Card } from 'antd';
import { PrmFactory } from 'rt-sd-common/sgiFactory/PrmFactory';
import { ObjFactory } from 'rt-sd-common/sgiFactory/ObjFactory';
import { convertModuleByGuid } from "rt-sd-comp/sgiComp/SgiCompComm";
import { createSimpleFormInfo } from './common'
const FormItem = Form.Item;
const Option = Select.Option;
import { Tree } from 'antd';
const TreeNode = Tree.TreeNode;
// import MainBreadcrumb from '../../main/MainBreadcrumb'
import { copy, uuid } from 'rt-sd-common/sgiCommon/sgiCommon';

const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 }
};

const formItemLayout2 = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 }
};

class ParamMngDefDisplay extends React.Component {
    constructor(props) {
        super(props);


        if (!this.props.guid) {
            return;
        }

        // let objFct = new ObjFactory(this.props.guid);

        let treeData = [];
        // let prm = PrmFactory.getPrm(this.props.guid);
        let prm = PrmFactory.getPrm("Emos_param_custAdvQuery_0001");
        if (prm.cldSet) {
            treeData = prm.cldSet;
        }

        this.state = {
            forms: {}, //客群定义显示form，一个属性一个form,{key:form,key2:form2}
            formsValue: {},
            showCtls: {}, //存储所有显示控件
            objFct: this.props.objFct,
            loading: false,
            checkedAtts: {},
            treeData: treeData,
            checkedKeys: [],
            expandedKeys: [],
            showSelCtls: this.props.showSelCtls || [],
            data: this.props.data || {},
            isShowAll: this.props.isShowAll,
            showCol: this.props.showCol || 1
        };

        if (this.state.isShowAll) {
            this.state.showSelCtls = treeData;
        }
    }

    convertData = (e) => {
        //校验 组装数据
        let errors = [];
        let errorMsg;
        for (var tmpKey in this.state.showCtls) {
            let tmpCtl = this.state.showCtls[tmpKey];
            let ctlDisplay = this.state.formsValue[tmpCtl.props.moduleDesc.cRef]["ctl2Display"];
            if (ctlDisplay != 'none') {
                errorMsg = tmpCtl.validate();
                if (errorMsg) {
                    errors.push(errorMsg);
                }
            }
        }

        if (errors.length > 0) {
            //组装数据
            this.setState({ loading: false })
            // alert('校验失败');
            return null;
        }

        let data = {};
        for (var tmpKey in this.state.checkedAtts) {
            let tmpSaveRecord = this.state.objFct.get(tmpKey + "_tmp");
            let matchType = tmpSaveRecord.match_type;
            let value = tmpSaveRecord[tmpKey];
            if (matchType == "Between" || matchType == "NotBetween") {
                value += "," + tmpSaveRecord.value2;
            }
            data[tmpKey] = value;
        }
        return data;
    }


    /**
     * 查找属性等于指定值的第一个子项
     * @param  {[String]} attribute [属性名称]
     * @param  {[Object]} value     [要搜索的值]
     * @param  {[Boolean]} deep = false      [true表示遍历所有子节点，false表示只遍历下一级]
     * @return {[type]}           [找到的子元素，如果没有找到，则返回null]
     */
    findChild(attribute, value, deep) {
        let me = this;
        return me.findChildBy(function () {
            return this[attribute] == value;
        }, null, deep, this.state.treeData);
    }
    /**
     * 通过自定义函数查找第一个子项。 如果传递的函数返回true，则该子项匹配。
     * @param  {Function} fn    [如果通过的节点是所需的节点，fn一个必须返回true的函数。]
     * @param  {[Object]}   scope [执行该函数的作用域（此引用）。 默认为正在测试的节点。]
     * @param  {[Boolean]}   deep = false  [true：搜索比直接子节点更深的节点]
     * @return {[type]}         [找到的子元素，如果没有找到，则返回null]
     */
    findChildBy(fn, scope, deep, cs) {
        // var cs = [];
        // if (this.state.treeData) {
        //     cs = this.state.treeData;
        // }
        var len = cs.length,
            i = 0,
            n, res;
        for (; i < len; i++) {
            n = cs[i];
            if (fn.call(scope || n, n) === true) {
                return n;
            } else if (deep && n.cldSet) {
                res = this.findChildBy(fn, scope, deep, n.cldSet);
                if (res !== null) {
                    return res;
                }
            }
        }
        return null;
    }

    /**
     * 接受显示控件属性
     * @param {*} showSelCtls 
     */
    refreshShowCtlsInfo(showSelCtls) {
        if (!showSelCtls) {
            return;
        }
        // this.state.showSelCtls = showSelCtls;
        this.refreshCtlsAndData(this.state.data,showSelCtls);
    }

    /**
     * 接受显示控件属性key
     * @param {*} showSelCtls 
     */
    refreshShowCtls(showSelCtls) {
        if (!showSelCtls) {
            return;
        }
        this.state.showSelCtls = showSelCtls;
        this.refreshData(this.state.data);
    }


    refreshCtlsAndData = (data,showSelCtls) => {
        //重置
        this.state.forms = {};
        this.state.formsValue = {};
        this.state.checkedAtts = {};
        this.state.showCtls = {};

        showSelCtls.forEach(item => {
            // let findRecord = this.findChild('id', item.id, true);
            let findRecord = item;
            if (findRecord) {
                let matchType = findRecord.matchType;
                // let ctl2Display = "none";
                let value = data ? data[findRecord.c || findRecord.skvyiCode] : "";
                let value1 = value, value2;
                if (matchType == "Between" || matchType == "NotBetween") {
                    ctl2Display = undefined;
                    let values = value.split(",");
                    value1 = values[0];
                    value2 = values[1];
                }
                this.state.formsValue[findRecord.c || findRecord.skvyiCode] = data || {};
                this.createSimpleFormInfo(this, findRecord, matchType, value1, value2);
            }

        });

        this.setState({ loading: false });
    }

    refreshData = (data) => {
        //重置
        this.state.forms = {};
        this.state.formsValue = {};
        this.state.checkedAtts = {};
        this.state.showCtls = {};

        this.state.showSelCtls.forEach(item => {
            let findRecord = this.findChild('id', item.id, true);
            if (findRecord) {
                let matchType = findRecord.matchType;
                // let ctl2Display = "none";
                let value = data ? data[findRecord.c] : "";
                let value1 = value, value2;
                if (matchType == "Between" || matchType == "NotBetween") {
                    ctl2Display = undefined;
                    let values = value.split(",");
                    value1 = values[0];
                    value2 = values[1];
                }
                this.state.formsValue[findRecord.c] = data;
                this.createSimpleFormInfo(this, findRecord, matchType, value1, value2);
            }

        });

        this.setState({ loading: false });
    }

    createSimpleFormInfo(thisObj, dataRef, matchType, value1, value2) {

        dataRef.desId = dataRef.desId || "EP_EO_UI_3101";//添加默认值-文本框

        let attc = dataRef.c || dataRef.skvyiCode;
        let text = dataRef.te || dataRef.name;

        let bdInst = attc + "_tmp";

        //显示的所有属性的集合
        thisObj.state.checkedAtts[attc] = true;

        thisObj.state.objFct.set(bdInst, thisObj.state.formsValue[attc]);

        //修改c值，给每组值起同样的key
        dataRef.cRef = attc;
        let dataRef1 = copy(dataRef);
        dataRef1.c = attc;
        dataRef1.isLbl = true;
        if (value1) dataRef1.value = value1;
        let ctl1 = convertModuleByGuid(thisObj, dataRef1, bdInst, thisObj.state.objFct, "N");
        ctl1.ref = thisObj.refModalFunction.bind(thisObj);
        let dataRef2 = copy(dataRef);
        dataRef2.c = "value2";
        dataRef2.isLbl = false;
        dataRef2.te = '-';
        dataRef2.ctlW = 24;
        dataRef2.lblW = 2;
        dataRef2.alwBlk = true;
        if (value2) dataRef2.value = value2;
        let ctl2 = convertModuleByGuid(thisObj, dataRef2, bdInst, thisObj.state.objFct, "N");
        if (matchType && (matchType == "Between" || matchType == "NotBetween")) {
            ctl2.ref = thisObj.refModalFunction.bind(thisObj);
        } else {
            delete ctl2.ref;
        }

        thisObj.state.forms[attc] = <FormItem colon={false} key={uuid(8)} {...formItemLayout2} style={{ 'margin-bottom': "1px", 'margin-top': "-3px" }} hasFeedback={false} label={text}>
            {ctl1}
        </FormItem>
    }

    refModalFunction(ctl) {
        if (!ctl) {
            return;
        }
        let { moduleDesc, objFct } = ctl.props;
        this
            .state.showCtls[moduleDesc.cRef + moduleDesc.c] = ctl;
    }

    handleChange(attc, match_type, dataRef, value) {
        tool.sgiLogger.info(`selected ${attc}`);
        tool.sgiLogger.info(`selected ${match_type}`);
        tool.sgiLogger.info(`selected ${value}`);

        if (value == "Between" || value == "NotBetween") {
            this.state.formsValue[attc]["ctl2Display"] = undefined;
        } else {
            this.state.formsValue[attc]["ctl2Display"] = 'none';
        }
        this.state.formsValue[attc][match_type] = value;
        createFormInfo(this, dataRef, value); //重新创建
        this.setState({ loading: false })
    }

    renderCardNodes = (forms) => {

        let formsCtl = [];
        let i = 0;
        let ctlList;
        for (var key in forms) {
            if (i % 1 == 0) {
                ctlList = [<Col span={24}>{forms[key]}</Col>];
                formsCtl.push(<Row style={{ width: '100%' }}>
                    {ctlList}
                </Row >)
            } else {
                ctlList.push(<Col span={24}>{forms[key]}</Col>);
            }
            i++;
        }
        return formsCtl;
    }
    hasFlg = (obj) => {
        if (!obj) return false;
        if (obj instanceof Array) {
            for (let i = 0; i < obj.length; i++) {
                if (obj[i]) return true;
            }
            return false;
        }
    }

    render() {

        if (!this.props.guid) {
            return <div>guid不存在</div>;
        }

        var showList = this.renderCardNodes(this.state.forms);

        return (
            <div style={{ height: '100%', width: '100%' }}>
                {showList}
            </div >

        )
    }

    componentDidMount() {
        this.refreshData(this.state.data);
    }

}

export default ParamMngDefDisplay;



// WEBPACK FOOTER //
// ./apps/pages/paramMng/ParamMngDefDisplay.js